import { createStateSelectorHook } from 'src/lib/sweetState';

// @ts-expect-error - onboarding store has no TypeScript definitions yet
import { OnboardingStore } from './Store';

const useOnboardingState = createStateSelectorHook(OnboardingStore, ['isActive', 'currentStepId']);

// The step the walkthrough is showing, or `null` when it is showing nothing. Pausing leaves the
// walkthrough on its step while taking it off screen, so the step id alone answers for a tour the
// user cannot see.
export const useOnboardingActiveStepId = (): string | null => {
  const { isActive, currentStepId } = useOnboardingState();

  return isActive ? currentStepId : null;
};
